import * as types from './types'

const intialState = {
  group: {
    name: '',
    permissions: {
      roles: [],
      courses: [],
    },
    show_in_learning_plan: 1,
    owner: 0,
    dates_disabled: 0,
    status: null,
  },
  checklist: {
    sections: [],
    sectionActiveIndex: -1,
    description: {},
  },

  roles: [],
  groups: [],
  userTrainings: [],
  locations: [],
  selectedRoles: [],
  selectedRoleGroups: [],
  selectedUsers: [],
  selectedCourses: [],
  selectedCoursesWithPosition: [],
  selectedLocations: [],
  selectedStores: [],
  selectedGroups: [],
  groupsCourses: {},
  groupsCoursesAll: {},
  userGroupsCourses: [],
  userGroupsCoursesAll: [],
  groupIndex: 0,
  complianceGroupIndex: 0,
  complianceGroups: [],
  initialComplianceGroups: [],
  previousGroups: null,
  groupOrderShowing: false,
  complianceGroupOrderShowing: false,
  uploadGroupPercent: 0,
  uploadGroupStatus: '',
  xslxFile: null,
  learningPlanGroups: [],
  courseIndex: null,
  groupsCoursesLoaded: false,
  individualCourses: [],
  allCourses: [],
  groupCloneStatus: '',
  groupCloned: null,
  selectedGroupLocations: [],
  filterGroupCoursesValue: '',
  filterGroupLocationsValue: '',
  filterGroupUsersValue: '',
  filterGroupRolesValue: '',
  filterRoleGroupsValue: '',
  filterGroupAssociatesValue: '',
  startDate: null,
  endDate: null,
  tagDetails: [],
  tags: [],
  groupStatus: [],
  groupSearchValue: '',
  showSelectedItems: false,
  showSelectedLocationItems: false,
  showSelectedLocations: false,
  showSelectedStores: false,
  showSelectedRoles: false,
  showSelectedRoleGroups: false,
  searchByCourses: false,
  searchByGroups: true,
  groupWithCourses: [],
  groupWithCoursesAll: [],
  assignExpanded: false,
  manageExpanded: false,
  assignableTrainingUsers: [],
  manageableTrainingUsers: [],
  assignableTrainingLocations: [],
  manageableTrainingLocations: [],
  assignableTrainingStores: [],
  manageableTrainingStores: [],
  assignableTrainingRoles: [],
  assignableTrainingRoleGroups: [],
  manageableTrainingRoles: [],
  manageableTrainingRoleGroups: [],
  assignableTrainingLocationGroups: [],
  manageableTrainingLocationGroups: [],
  trainingCourses: [],
  trainings: [],
  trainingWithCourses: [],
  manageableTrainings: [],
  selectedLocationGroups: [],
  ownedGroups: [],
  groupsLoading: false,
  locationsLoading: false,
  duration: null,
  hasDuration: false,
  hasDate: false,
  datesDisabled: true,
  doNotAssign: false,
  automaticEnrollment: false,
  pinToNavbar: false,
  pinToNavbarDevelopment: false,
  enableReorder: false,
  hasExpireDate: false,
  expireDate: null,
  expirePeriod: 'm',
  reassignDate: null,
  expirePrior: 'd',
  groupOrgs: [],
  allGroups: [],
  inactive: false,
  equivalentGroup: null,
  locationGroups: [],
  roleGroups: [],
  searchGroupOnClick: '',
  prevChecklistDescription: '',
  coreGroupsCourses: [],
  userRoleSelected: null,
  userRoles: [],
  setUserNotAssignedFromRole: [],
}

const groupReducer = (state = intialState, action) => {
  switch (action.type) {
    case types.SET_GROUP:
      return {
        ...state,
        group: {
          ...state.group,
          ...action.group,
        },
        startDate: action.startDate,
        endDate: action.endDate,
        duration: action.duration,
        datesDisabled: action.datesDisabled,
        hasDate: action.hasDate,
        hasDuration: action.hasDuration,
        doNotAssign: action.doNotAssign,
        automaticEnrollment: action.automaticEnrollment,
        pinToNavbar: action.pinToNavbar,
        pinToNavbarDevelopment: action.pinToNavbarDevelopment,
        enableReorder: action.enableReorder,
        expireDate: action.expireDate,
        inactive: action.inactive,
        equivalentGroup: action.equivalentGroup,
        hasExpireDate: action.hasExpireDate,
        reassignDate: action.reassignDate,
        checklist: {
          ...action.checklist,
          sectionActiveIndex: -1,
          sections: action.checklist.sections || [],
        },
      }

    case types.SET_GROUP_COURSES_WITH_POSITION:
      return {
        ...state,
        selectedCoursesWithPosition: action.courses,
      }
    case types.SET_GROUP_COURSES:
      return {
        ...state,
        selectedCourses: action.courses,
      }
    case types.SET_GROUP_USERS:
      return {
        ...state,
        selectedUsers: action.users,
      }
    case types.SET_GROUP_LOCATIONS:
      return {
        ...state,
        selectedLocations: action.locations,
      }
    case types.SET_GROUP_STORES:
      return {
        ...state,
        selectedStores: action.stores,
      }
    case types.SET_LOCATION_GROUPS:
      return {
        ...state,
        locationGroups: action.locationGroups,
      }
    case types.SET_ROLE_GROUP_GROUPS:
      return {
        ...state,
        roleGroups: action.roleGroups,
      }
    case types.SET_GROUP_ROLES:
      return {
        ...state,
        selectedRoles: action.roles,
      }
    case types.SET_ROLE_GROUPS:
      return {
        ...state,
        selectedRoleGroups: action.roleGroups,
      }
    case types.SET_GROUP_LOCATION_GROUPS:
      return {
        ...state,
        selectedLocationGroups: action.locationGroups,
      }
    case types.SET_LOCATIONS:
      return {
        ...state,
        locations: action.locations,
      }
    case types.SET_GROUPS:
      return {
        ...state,
        groups: action.groups,
      }
    case types.PROPERTY_GROUP_NAME_CHANGE:
      return {
        ...state,
        group: {
          ...state.group,
          name: action.value,
        },
      }
    case types.PROPERTY_GROUP_COURSES_CHANGE:
      return {
        ...state,
        selectedCourses: action.courses,
      }
    case types.GROUP_COURSE_POSITION_CHANGE:
      return {
        ...state,
        selectedCoursesWithPosition: action.courses,
      }
    case types.RESET_SELECTED_ITEMS:
      return {
        ...state,
        selectedRoles: [],
        selectedRoleGroups: [],
        selectedUsers: [],
        selectedGroups: [],
        selectedLocations: [],
        selectedStores: [],
        selectedLocationGroups: [],
        assignableTrainingUsers: [],
        manageableTrainingUsers: [],
        assignableTrainingRoles: [],
        assignableTrainingRoleGroups: [],
        manageableTrainingRoles: [],
        manageableTrainingRoleGroups: [],
        assignableTrainingLocations: [],
        assignableTrainingStores: [],
        manageableTrainingLocations: [],
        assignableTrainingLocationGroups: [],
        manageableTrainingLocationGroups: [],
      }
    case types.RESET_GROUP_DETAILS_DATA:
      return {
        ...state,
        group: {
          name: '',
          permissions: {
            roles: [],
            courses: [],
          },
          show_in_learning_plan: 1,
          owner: 0,
          dates_disabled: 0,
          status: null,
        },
        checklist: {
          sections: [],
          sectionActiveIndex: -1,
          description: {},
        },
        selectedRoles: [],
        selectedRoleGroups: [],
        selectedUsers: [],
        selectedLocations: [],
        selectedGroups: [],
        selectedLocationGroups: [],
        selectedCourses: [],
        selectedCoursesWithPosition: [],
        selectedRoles: [],
        selectedUsers: [],
        selectedGroups: [],
        selectedStores: [],
        selectedLocationGroups: [],
        assignableTrainingUsers: [],
        manageableTrainingUsers: [],
        assignableTrainingRoles: [],
        assignableTrainingRoleGroups: [],
        manageableTrainingRoles: [],
        manageableTrainingRoleGroups: [],
        assignableTrainingLocations: [],
        assignableTrainingStores: [],
        manageableTrainingLocations: [],
        assignableTrainingLocationGroups: [],
        manageableTrainingLocationGroups: [],
        duration: null,
        hasDuration: false,
        hasDate: false,
        datesDisabled: true,
        doNotAssign: false,
        automaticEnrollment: false,
        pinToNavbar: false,
        pinToNavbarDevelopment: false,
        enableReorder: false,
        startDate: null,
        endDate: null,
        hasExpireDate: false,
        expireDate: null,
        expirePeriod: 'months',
        reassignDate: null,
        expirePrior: 'days',
      }
    case types.RESET_GROUP:
      return intialState

    case types.SET_SELECTED_ROLES:
      return {
        ...state,
        userRoleSelected: action.payload,
      }
    case types.SET_USER_ROLES:
      return {
        ...state,
        userRoles: action.payload,
      }

    case types.SET_USERS_NOT_ASSIGNED_FROM_ROLE:
      return {
        ...state,
        setUserNotAssignedFromRole: action.payload,
      }

    case types.SET_ROLES:
      return {
        ...state,
        roles: action.roles,
      }
    case types.SELECT_ROLE:
      return {
        ...state,
        selectedRoles: action.roles,
      }
    case types.SELECT_ROLE_GROUPS:
      return {
        ...state,
        selectedRoleGroups: action.roleGroups,
      }
    case types.SET_GROUP_ASSOCIATES:
      return {
        ...state,
        selectedGroups: action.groups,
      }
    case types.TOGGLE_LEARNING_PLAN:
      return {
        ...state,
        group: {
          ...state.group,
          show_in_learning_plan: action.show,
        },
      }
    case types.SET_GROUPS_COURSES:
      return {
        ...state,
        groupsCourses: action.courses,
      }
    case types.SET_USER_GROUPS_COURSES:
      return {
        ...state,
        userGroupsCourses: action.data,
      }
    case types.SET_GROUPS_COURSES_DATA:
      return {
        ...state,
        groupsCoursesData: action.courses,
      }
    case types.SET_GROUP_INDEX:
      return {
        ...state,
        groupIndex: action.index,
      }
    case types.SET_COMPLIANCE_GROUP_INDEX:
      return {
        ...state,
        complianceGroupIndex: action.index,
      }
    case types.SET_COMPLIANCE_GROUPS:
      return {
        ...state,
        complianceGroups: action.payload,
      }
    case types.SET_INITIAL_COMPLIANCE_GROUPS:
      return {
        ...state,
        initialComplianceGroups: action.payload,
      }
    case types.PRESENT:
      return {
        ...state,
        previousGroups: JSON.stringify(state.learningPlanGroups),
        previousGroupsCourses: JSON.stringify(state.groupsCourses),
      }
    case types.UNDO:
      return {
        ...state,
        learningPlanGroups: JSON.parse(state.previousGroups),
        groupsCourses: JSON.parse(state.previousGroupsCourses),
      }
    case types.CANCEL_SECTION:
      return {
        ...state,
        checklist: {
          ...state.checklist,
          sections: state.checklist.sections.filter((item) => !item.onCreate),
          description: state.prevChecklistDescription,
        },
      }
    case types.PREV_CHECKLIST_DESCRIPTION:
      return {
        ...state,
        prevChecklistDescription: action.value,
      }
    case types.TOGGLE_GROUP:
      return {
        ...state,
        groupOrderShowing: action.isShowing,
      }
    case types.TOGGLE_COMPLIANCE_GROUP:
      return {
        ...state,
        complianceGroupOrderShowing: action.isShowing,
      }
    case types.SELECT_GROUP_FILE:
      return {
        ...state,
        xslxFile: action.file,
      }
    case types.UPLOAD_GROUP_STATUS:
      return {
        ...state,
        uploadGroupStatus: action.status,
      }
    case types.UPLOAD_GROUP_PERCENT:
      return {
        ...state,
        uploadGroupPercent: action.percent,
      }
    case types.SET_GROUPS_LEARNING_PLAN:
      return {
        ...state,
        learningPlanGroups: action.groups,
      }
    case types.SET_COURSE_INDEX:
      return {
        ...state,
        courseIndex: action.index,
      }
    case types.SET_CORE_GROUP_COURSES:
      return {
        ...state,
        coreGroupsCourses: action.groups,
      }
    case types.GROUPS_COURSES_LOADED:
      return {
        ...state,
        groupsCoursesLoaded: true,
      }
    case types.SET_INDIVIDUAL_COURSES:
      return {
        ...state,
        individualCourses: action.courses,
      }
    case types.SET_ALL_COURSES:
      return {
        ...state,
        allCourses: action.courses,
      }
    case types.GROUP_CLONE_STATUS:
      return {
        ...state,
        groupCloneStatus: action.status,
      }
    case types.GROUP_CLONED:
      return {
        ...state,
        groupCloned: action.data,
      }
    case types.FILTER_GROUP_COURSES:
      return {
        ...state,
        filterGroupCoursesValue: action.value,
      }
    case types.FILTER_GROUP_LOCATIONS:
      return {
        ...state,
        filterGroupLocationsValue: action.value,
      }
    case types.FILTER_GROUP_USERS:
      return {
        ...state,
        filterGroupUsersValue: action.value,
      }
    case types.FILTER_GROUP_ROLES:
      return {
        ...state,
        filterGroupRolesValue: action.value,
      }
    case types.FILTER_ROLE_GROUPS:
      return {
        ...state,
        filterRoleGroupsValue: action.value,
      }
    case types.FILTER_GROUP_ASSOCIATES:
      return {
        ...state,
        filterGroupAssociatesValue: action.value,
      }
    case types.ASSING_GROUP_LOCATION:
      return {
        ...state,
        selectedGroupLocations: action.locations,
      }
    case types.SET_GROUP_DATES:
      return {
        ...state,
        startDate: action.startDate,
        endDate: action.endDate,
      }
    case types.TOGGLE_DATES:
      return {
        ...state,
        group: {
          ...state.group,
          dates_disabled: action.dates_disabled,
        },
        startDate: null,
        endDate: null,
      }
    case types.SET_TAG_DETAILS:
      return {
        ...state,
        tagDetails: action.tagDetails,
      }
    case types.SET_TAGS:
      return {
        ...state,
        tags: action.tags,
      }
    case types.SET_GROUP_OWNER:
      return {
        ...state,
        group: {
          ...state.group,
          owner: action.owner,
        },
      }
    case types.SET_SINGLE_GROUP_INACTIVE:
      return {
        ...state,
        group: {
          ...state.group,
          inactive: action.inactive,
        },
      }
    case types.SET_GROUP_STATUS:
      return {
        ...state,
        groupStatus: action.groupStatus,
      }
    case types.SET_GROUP_SEARCH_VALUE:
      return {
        ...state,
        groupSearchValue: action.value,
      }
    case types.SET_SEARCH_GROUP_ON_CLICK:
      return {
        ...state,
        searchGroupOnClick: action.value,
      }
    case types.SET_SHOW_SELECTED_ITEMS:
      return {
        ...state,
        showSelectedItems: action.showSelectedItems,
      }
    case types.SET_SHOW_SELECTED_LOCATION_ITEMS:
      return {
        ...state,
        showSelectedLocationItems: action.showSelectedLocationItems,
      }
    case types.SET_SHOW_SELECTED_LOCATION:
      return {
        ...state,
        showSelectedLocations: action.showSelectedLocations,
      }
    case types.SET_SHOW_SELECTED_STORES:
      return {
        ...state,
        showSelectedStores: action.showSelectedStores,
      }
    case types.SET_SHOW_SELECTED_ROLES:
      return {
        ...state,
        showSelectedRoles: action.showSelectedRoles,
      }
    case types.SET_SHOW_SELECTED_ROLE_GROUPS:
      return {
        ...state,
        showSelectedRoleGroups: action.showSelectedRoleGroups,
      }
    case types.SET_SEARCH_BY_COURSES:
      return {
        ...state,
        searchByCourses: action.searchByCourses,
      }
    case types.SET_SEARCH_BY_GROUPS:
      return {
        ...state,
        searchByGroups: action.searchByGroups,
      }
    case types.SET_GROUPS_WITH_COURSES:
      return {
        ...state,
        groupWithCourses: action.groups,
      }
    case types.SET_ASSIGN_EXPANDED:
      return {
        ...state,
        assignExpanded: action.assignExpanded,
      }
    case types.SET_MANAGE_EXPANDED:
      return {
        ...state,
        manageExpanded: action.manageExpanded,
      }
    case types.SET_USER_TRAINING:
      return {
        ...state,
        userTrainings: action.userTrainings,
      }
    case types.SET_SELECTED_ASSIGNABLE_TRAINING_USERS:
      return {
        ...state,
        assignableTrainingUsers: action.assignableTrainingUsers,
      }
    case types.SET_SELECTED_MANAGEABLE_TRAINING_USERS:
      return {
        ...state,
        manageableTrainingUsers: action.manageableTrainingUsers,
      }
    case types.SET_SELECTED_ASSIGNABLE_TRAINING_LOCATIONS:
      return {
        ...state,
        assignableTrainingLocations: action.assignableTrainingLocations,
      }
    case types.SET_SELECTED_MANAGEABLE_TRAINING_LOCATIONS:
      return {
        ...state,
        manageableTrainingLocations: action.manageableTrainingLocations,
      }
    case types.SET_SELECTED_ASSIGNABLE_TRAINING_STORES:
      return {
        ...state,
        assignableTrainingStores: action.assignableTrainingStores,
      }
    case types.SET_SELECTED_MANAGEABLE_TRAINING_STORES:
      return {
        ...state,
        manageableTrainingStores: action.manageableTrainingStores,
      }
    case types.SET_SELECTED_MANAGEABLE_TRAINING_ROLES:
      return {
        ...state,
        manageableTrainingRoles: action.manageableTrainingRoles,
      }
    case types.SET_SELECTED_ASSIGNABLE_TRAINING_ROLES:
      return {
        ...state,
        assignableTrainingRoles: action.assignableTrainingRoles,
      }
    case types.SET_SELECTED_MANAGEABLE_TRAINING_ROLE_GROUPS:
      return {
        ...state,
        manageableTrainingRoleGroups: action.manageableTrainingRoleGroups,
      }
    case types.SET_SELECTED_ASSIGNABLE_TRAINING_ROLE_GROUPS:
      return {
        ...state,
        assignableTrainingRoleGroups: action.assignableTrainingRoleGroups,
      }
    case types.SET_SELECTED_MANAGEABLE_TRAINING_LOCATION_GROUPS:
      return {
        ...state,
        manageableTrainingLocationGroups:
          action.manageableTrainingLocationGroups,
      }
    case types.SET_SELECTED_ASSIGNABLE_TRAINING_LOCATION_GROUPS:
      return {
        ...state,
        assignableTrainingLocationGroups:
          action.assignableTrainingLocationGroups,
      }
    case types.SET_TRAINING_COURSES:
      return {
        ...state,
        trainingCourses: action.trainingCourses,
      }
    case types.SET_TRAININGS:
      return {
        ...state,
        trainings: action.trainings,
      }
    case types.SET_TRAININGS_WITH_COURSES:
      return {
        ...state,
        trainingWithCourses: action.trainings,
      }
    case types.SET_MANAGEABLE_TRAININGS:
      return {
        ...state,
        manageableTrainings: action.trainings,
      }
    case types.SET_OWNED_GROUPS:
      return {
        ...state,
        ownedGroups: action.data,
      }
    case types.SET_LOADING:
      return {
        ...state,
        groupsLoading: action.value,
      }
    case types.SET_LOCATIONS_LOADING:
      return {
        ...state,
        locationsLoading: action.value,
      }
    case types.SET_TRAINING_DURATION:
      return {
        ...state,
        duration: action.value,
      }
    case types.RESET_TRAINING_DATES:
      return {
        ...state,
        startDate: null,
        endDate: null,
      }
    case types.SET_EXPIRATION_TO_DISABLED:
      return {
        ...state,
        hasDuration: false,
        hasDate: false,
        datesDisabled: true,
      }
    case types.SET_EXPIRATION_TO_DATE:
      return {
        ...state,
        hasDate: true,
        hasDuration: false,
        datesDisabled: false,
      }

    case types.SET_EXPIRATION_TO_DURATION:
      return {
        ...state,
        hasDuration: true,
        hasDate: false,
        datesDisabled: false,
      }

    case types.TOGGLE_DO_NOT_ASSIGN:
      return {
        ...state,
        doNotAssign: !state.doNotAssign,
      }
    case types.TOGGLE_AUTOMATIC_ENROLLMENT:
      return {
        ...state,
        automaticEnrollment: !state.automaticEnrollment,
      }
    case types.TOGGLE_PIN_TO_NAVBAR:
      return {
        ...state,
        pinToNavbar: action.show,
      }
    case types.TOGGLE_PIN_TO_NAVBAR_DEVELOPMENT:
      return {
        ...state,
        pinToNavbarDevelopment: action.show,
      }
    case types.TOGGLE_ENABLE_REORDER:
      return {
        ...state,
        enableReorder: !state.enableReorder,
      }
    case types.TOGGLE_EXPIRE_DATE:
      return {
        ...state,
        hasExpireDate: !state.hasExpireDate,
      }
    case types.SET_EXPIRE_DATE:
      return {
        ...state,
        expireDate: action.value,
      }
    case types.SET_EXPIRE_PERIOD:
      return {
        ...state,
        expirePeriod: action.value,
      }
    case types.SET_REASSIGN_DATE:
      return {
        ...state,
        reassignDate: action.value,
      }
    case types.SET_EXPIRE_PRIOR:
      return {
        ...state,
        expirePrior: action.value,
      }
    case types.SET_ORG_GROUPS:
      return {
        ...state,
        groupOrgs: action.data,
      }
    case types.SET_ALL_GROUPS:
      return {
        ...state,
        allGroups: action.groups,
      }
    case types.SET_GROUP_INACTIVE:
      return {
        ...state,
        inactive: !state.inactive,
      }
    case types.SET_EQUIVALENT_GROUP:
      return {
        ...state,
        equivalentGroup: action.value,
      }
    case types.SET_GROUPS_COURSES_DATA_ALL:
      return {
        ...state,
        groupsCoursesDataAll: action.courses,
      }
    case types.SET_GROUPS_COURSES_ALL:
      return {
        ...state,
        groupsCoursesAll: action.courses,
      }
    case types.SET_GROUPS_WITH_COURSES_ALL:
      return {
        ...state,
        groupWithCoursesAll: action.groups,
      }
    case types.SET_USER_GROUPS_COURSES_ALL:
      return {
        ...state,
        userGroupsCoursesAll: action.data,
      }
    case types.ADD_SECTION:
      return {
        ...state,
        checklist: {
          ...state.checklist,
          sections: action.sections,
        },
      }
    case types.UPDATE_DESCRIPTION:
      console.log(action.name, 'name')
      console.log(action.value, 'value')

      return {
        ...state,
        checklist: {
          ...state.checklist,
          [action.name]: action.value,
        },
      }
    case types.SECTION_ACTIVE_INDEX:
      return {
        ...state,
        checklist: {
          ...state.checklist,
          sectionActiveIndex: action.index,
        },
      }
    case types.CHECKLIST:
      return {
        ...state,
        checklist: {
          ...state.checklist,
          sectionActiveIndex: 1,
        },
      }
    default:
      return state
  }
}

export default groupReducer
